<template>
  <el-container class="layout">
    <el-aside width="200px">
      <div class="logo">红包埋雷后台</div>
      <el-menu
        router
        :default-active="$route.path"
        background-color="#1f2f3d"
        text-color="#bfcbd9"
        active-text-color="#67C23A"
      >
        <el-menu-item index="/users">用户管理</el-menu-item>
        <el-menu-item index="/rules">玩法管理</el-menu-item>
        <el-menu-item index="/groups">群聊管理</el-menu-item>
        <el-menu-item index="/funds">资金明细</el-menu-item>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header class="header" height="56px">
        <span>{{ $route.meta.title || '管理后台' }}</span>
        <div>
          <span class="ml8">{{ name }}</span>
          <el-button type="text" class="ml8" style="color:#F56C6C" @click="openClear">清除数据</el-button>
          <el-button type="text" class="ml8" @click="openPassword">修改密码</el-button>
          <el-button type="text" class="ml8" @click="logout">退出</el-button>
        </div>
      </el-header>
      <el-dialog title="修改密码" :visible.sync="pwdDialog" width="420px" append-to-body>
        <el-form :model="pwdForm" label-width="90px">
          <el-form-item label="原密码">
            <el-input v-model="pwdForm.oldPassword" type="password" show-password autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="新密码">
            <el-input v-model="pwdForm.newPassword" type="password" show-password autocomplete="off" placeholder="至少4位"></el-input>
          </el-form-item>
          <el-form-item label="确认新密码">
            <el-input v-model="pwdForm.confirmPassword" type="password" show-password autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="pwdDialog = false">取消</el-button>
          <el-button type="primary" :loading="pwdLoading" @click="submitPassword">保存</el-button>
        </div>
      </el-dialog>
      <el-dialog title="清除数据" :visible.sync="clearDialog" width="460px" append-to-body @closed="resetClear">
        <p class="clear-tip">将清除所有群聊中的聊天记录、发包记录、抢包记录和资金明细。</p>
        <p class="clear-tip">玩法、群聊和用户数据不会被清除。</p>
        <div slot="footer">
          <el-button @click="clearDialog = false">取消</el-button>
          <el-button type="danger" :loading="clearLoading" @click="submitClear">确认清除</el-button>
        </div>
      </el-dialog>
      <el-main class="main">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { changePassword, clearBusinessData } from '../api'

export default {
  name: 'Layout',
  data() {
    return {
      name: localStorage.getItem('admin_name') || '管理员',
      pwdDialog: false,
      pwdLoading: false,
      pwdForm: { oldPassword: '', newPassword: '', confirmPassword: '' },
      clearDialog: false,
      clearLoading: false
    }
  },
  methods: {
    openClear() {
      this.clearDialog = true
    },
    resetClear() {
      this.clearLoading = false
    },
    submitClear() {
      this.clearLoading = true
      clearBusinessData().then(() => {
        this.clearDialog = false
        this.$message.success('数据已清除')
        this.$router.go(0)
      }).catch((e) => {
        this.$message.error(e.message)
      }).then(() => {
        this.clearLoading = false
      })
    },
    openPassword() {
      this.pwdForm = { oldPassword: '', newPassword: '', confirmPassword: '' }
      this.pwdDialog = true
    },
    submitPassword() {
      if (!this.pwdForm.oldPassword) {
        this.$message.error('请输入原密码')
        return
      }
      if (!this.pwdForm.newPassword || this.pwdForm.newPassword.length < 4) {
        this.$message.error('新密码至少4位')
        return
      }
      if (this.pwdForm.newPassword !== this.pwdForm.confirmPassword) {
        this.$message.error('两次输入的新密码不一致')
        return
      }
      this.pwdLoading = true
      changePassword({
        oldPassword: this.pwdForm.oldPassword,
        newPassword: this.pwdForm.newPassword
      }).then(() => {
        this.pwdDialog = false
        this.$message.success('密码已修改，请重新登录')
        this.logout()
      }).catch((e) => {
        this.$message.error(e.message)
      }).then(() => {
        this.pwdLoading = false
      })
    },
    logout() {
      localStorage.removeItem('admin_token')
      localStorage.removeItem('admin_name')
      this.$router.replace('/login')
    }
  }
}
</script>
